<template>
  <svg class="chevron" width="10" height="24" viewBox="0 0 10 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M1.80892 23.588L0.191918 22.412L7.76392 12L0.190918 1.58799L1.80792 0.411987L9.80792 11.412C10.0629 11.763 10.0629 12.237 9.80792 12.588L1.80892 23.588Z"
        fill="white"/>
  </svg>
</template>
<script>
export default {
  name: 'ChevronIcon'
}
</script>